import { Button, Form, Input, Message, Modal, Space, Table } from "@arco-design/web-react"
import { IconDelete, IconLock } from "@arco-design/web-react/icon";
import OperationButton from "@/components/OperationButton";
import { CompanyAPI, UserAPI } from "@/apis/system";
import { useCallback, useEffect, useState } from "react";

const FormItem = Form.Item;

export const Users = (props) => {
    const [data, setData] = useState([]);
    const [userFormVisible, setUserFormVisible] = useState(false);
    const [userForm] = Form.useForm();

    const getUsers = useCallback(async () => {
        const values = await CompanyAPI.users();
        setData(values);
    }, []);

    const resetPassword = async (id) => {
        await UserAPI.resetPassword(id);
        Message.success("Password reset successfully");
    }

    const deleteUser = async (id) => {
        await CompanyAPI.deleteUser(id);
        getUsers();
    }

    const addUser = async () => {
        const values = await userForm.validate();
        await CompanyAPI.addUser(values);
        setUserFormVisible(false);
        getUsers();
    }

    useEffect(() => {
        getUsers();
    }, [getUsers])

    return (
        <div>
            <div>
                <Button type="primary" size="small" onClick={() => {
                    userForm.resetFields();
                    setUserFormVisible(true);
                }}>Add New User</Button>
            </div>
            <div style={{ marginTop: 10 }}>
                <Table rowKey="id" columns={[
                    { title: "Name", dataIndex: "fullName" },
                    { title: "Email/User Name", dataIndex: "userName" },
                    {
                        title: "Operation", dataIndex: "op", width: 100,
                        render: (col, record, index) => {
                            return (
                                <Space>
                                    <OperationButton icon={<IconLock />} label="Reset Password" status="warning"
                                        onClick={() => resetPassword(record.id)} />
                                    <OperationButton icon={<IconDelete />} label="Delete" status="danger"
                                        onClick={() => deleteUser(record.id)} />
                                </Space>
                            )
                        }
                    },
                ]} data={data} />
                {userFormVisible &&
                    <Modal title="User" visible
                        onConfirm={() => addUser()}
                        onCancel={() => setUserFormVisible(false)}>
                        <Form form={userForm} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                            <FormItem label="First Name" field="firstName" required rules={[{ required: true }]}>
                                <Input />
                            </FormItem>
                            <FormItem label="Last Name" field="lastName" required rules={[{ required: true }]}>
                                <Input />
                            </FormItem>
                            <FormItem label="Email" field="email" required rules={[{ required: true }, { type: "email" }]}>
                                <Input />
                            </FormItem>
                        </Form>
                    </Modal>
                }
            </div>
        </div>

    )
}